// extracted by mini-css-extract-plugin
export default {"markdown":"WebGLUnavailableModal_markdown__Jo3mw","footerActions":"WebGLUnavailableModal_footerActions__a2dlu"};